import React from "react";
import { Link } from "react-router-dom";
import Button from "components/UI/Button";
import Input from "components/UI/Input";
import "./style.css";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL, ERROR_HANDLE } from "config/constants";

class LoginScreen extends React.Component {
  state = {
    email: "",
    password: ""
  };
  loginactions = res => {
    toast("Logged In Successfully...");
    localStorage.setItem("email", res.data.email);
    localStorage.setItem("access_token", res.data.access_token);
    localStorage.setItem("restricted_access", res.data.restricted_access);
    localStorage.setItem("access_level", res.data.access_level);
    window.location.assign("/users/");
  };

  login = (email, password) => {
    axios
      .post(`${API_URL}/admin/login`, {
        email,
        password
      })
      .then(res => {
        this.loginactions(res);
      })
      .catch(err => {
        ERROR_HANDLE(err);
        this.setState({ email: "", password: "" });
      });
  };
  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.login(this.state.email, this.state.password);
    }
  };

  render() {
    const { email, password } = this.state;
    return (
      <div className="div_LoginScreen">
        <Input
          type="text"
          placeholder="Email"
          value={email}
          onChange={e => {
            this.setState({ email: e.target.value });
          }}
          onKeyPress={this.handleKeyPress}
        />
        <Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => {
            this.setState({ password: e.target.value });
          }}
          onKeyPress={this.handleKeyPress}
        />
        <br />
        <br />
        <br />
        <Button
          type="primary"
          rectangle
          onClick={() => {
            this.login(this.state.email, this.state.password);
          }}
        >
          <span
            style={{
              lineHeight: 2.17,
              letterSpacing: "5.5px",
              textAlign: "center"
            }}
          >
            LOG IN
          </span>
        </Button>
        <br />
        <br />
        <br />
        <div className="div_LoginScreenLinkToForgotPassword">
          <Link
            to="forgotpassword"
            style={{
              textDecoration: "none",
              fontSize: "15px",
              color: "var(--secondary)",
              textAlign: "left"
            }}
          >
            <p className="p_LinkToForgotPassword">forgot password?</p>
          </Link>
        </div>
      </div>
    );
  }
}

export default LoginScreen;
